<form [formGroup]="formGroup" class="mfis">
  @for (element of elements; track element.name) {
    @if (element.type === "section" && getQuestionInstruction(element.title)) {
      <div class="mfis-instruction">
        {{ getQuestionInstruction(element.title) }}
      </div>
    }
    @if (element.type === "radiogroup") {
      <div class="mfis-row">
        <div class="mfis-q">
          <div class="mfis-q-title">{{ getItemTitle(element) }}</div>
        </div>
        <div class="mfis-a">
          <nz-radio-group
            class="mfis-segment"
            [nzButtonStyle]="'solid'"
            [formControlName]="element.name"
          >
            @for (choice of getOrderedChoices(element); track choice.value) {
              <label
                nz-radio-button
                [nzValue]="choice.value"
                (click)="onRadioClick(element.name, choice.value, $event)"
              >
                {{ choice.text }}
                {{ getChoicePoints(choice.text) }}
              </label>
            }
          </nz-radio-group>
        </div>
      </div>
    }
    @if (isScoreElement(element)) {
      <div
        class="mfis-score"
        [class.mfis-total]="isTotalScoreElement(element)"
      >
        <div class="mfis-score-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="mfis-score-value">
          {{ getScoreDisplay(element.name) }} /
          {{ getMaxScore(element.name) }}
        </div>
      </div>
    }
  }
</form>
